import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
// import { InventoryItemService } from '../../features/inventory/services/inventory.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { PAYMENT_MODES } from '../../helpers/helper-file';
import { fetch_PDF } from '../../helpers/helper';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { PaymentsService } from '../../features/payments/services/payments.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-payment-received-details',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    // PermissionDirective
  ],
  templateUrl: './payment-received-details.component.html',
  styleUrl: './payment-received-details.component.scss',
})
export class PaymentReceivedDetailsComponent {
  commentsForm: FormGroup;
  public loading: boolean = true;
  allItems: any[] = [];
  itemData: any = {};
  isLoading = false;
  private searchSubject = new Subject<string>();
  commentsList: any;
  paymentModeList: any = PAYMENT_MODES;
  selectedModes: string[] = [];
  selectedCount: number = 0;
  itemId: any;
  journalData: any;
  search: any;
  // Permission = Permission;
  pdfLoading: boolean = false;
  canCreatePaymentReceived$ = this.permissionService.hasPermission(
      ModuleIds.PaymentReceived,
      'Create'
    );
    canEditPaymentReceived$ = this.permissionService.hasPermission(
      ModuleIds.PaymentReceived,
      'Edit'
    );
    canApproveCancelPaymentReceived$ = this.permissionService.hasPermission(
      ModuleIds.PaymentReceived,
      'Approve/Cancel'
    );

  constructor(
    private itemService: PaymentsService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    console.log('ngoninit');

    this.fetchItems();
    this.initForm();

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search = searchTerm;
        this.fetchItems();
      });

    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      this.itemId = Number(id);
    });
    console.log('this.itemId', this.itemId);
  }

  initForm(): void {
    this.commentsForm = this.fb.group({
      comments: ['', Validators.required],
    });
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  navigateToEdit(path: string) {
    const selectedIteam = this.allItems[this.selectedTabIndex];
    const itemId = selectedIteam.id;
    this.router.navigate([path], { queryParams: { id: itemId } });
  }

  selectedOption = 'today';

  selectedTabIndex = 0; // Default to the first tab

  selectTab(id: number, index: number) {
    this.itemService.payment(id).subscribe({
      next: (data) => {
        this.itemData = data;
        console.log('this.itemData', this.itemData);
        this.selectedTabIndex = index;

        this.journalData = this.itemData?.journalData;
        // this.vendorAddresses = this.itemData.partner?.addresses.filter(
        //   (address: any) => address.addressType === 'BILLING'
        // ) || [];
        // this.billingAddress = this.vendorAddresses.find(
        //   (address: any) => address.addressType === 'BILLING'
        // ) || null;
        // console.log('Vendor Addresses:', this.vendorAddresses);
        if (this.itemData) {
          this.router.navigate(['payment-received/payment-received-details'], {
            queryParams: { id: this.itemData.id },
          });
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  handleApproval(isApproved: boolean): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: isApproved ? 'Confirm Approval' : 'Confirm Cancellation',
        message: isApproved
          ? 'Are you sure you want to approve this bill?'
          : 'Are you sure you want to cancel this bill?',
        confirmText: 'Confirm',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        if (isApproved) {
          this.itemService.approvePayment(this.itemId).subscribe({
            next: (res) => {
              // console.log(res);
              this.generatePdf();
              this.toastr.success('Bill status updated.');
              this.navigateTo('/payment-received');
            },
            error: (err) => {
              console.error('Error updating bill status:', err);
            },
          });
        } else {
          this.itemService.cancelPayment(this.itemId).subscribe({
            next: (res) => {
              // console.log(res);
              this.toastr.success('Bill status updated.');
              this.navigateTo('/payment-received');
            },
            error: (err) => {
              console.error('Error updating bill status:', err);
            },
          });
        }
      }
    });
  }

  generatePdf() {
    this.itemService.generatePaymentPdf(Number(this.itemId)).subscribe({
      next: (res) => {
        this.toastr.success('Payment received pdf successfully generated');
      },
      error: (err) => {
        console.log('Error in generate pdf', err);
      },
    });
  }

  calculateTotalDebit(entries: any[]): number {
    return (
      entries?.reduce((total, entry) => total + (entry.debit || 0), 0) || 0
    );
  }

  calculateTotalCredit(entries: any[]): number {
    return (
      entries?.reduce((total, entry) => total + (entry.credit || 0), 0) || 0
    );
  }
  readonly dialog = inject(MatDialog);

  // openDialog() {
  //   const dialogRef = this.dialog.open(UploadPaymentReceivedDetailsDialog);
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result === 'refresh') {
  //       this.fetchItems();
  //     }
  //   });
  // }

  isDropdownOpen = false;
  isDropdownOpenCmd = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  navigateToMail(): void {
    const paymentID = this.itemData.id;
    const paymentReceivedId = this.itemData.id;
    const ids =
      this.itemData?.paymentInfo?.map((info: any) => info?.invoice?.id) || [];

    // this.router.navigate([`payment-received/payment-received-details/mail`], {
    //   queryParams: { paymentID, ids },
    // });
    this.router.navigate([`payment-received/payment-received-details/mail`], {
      queryParams: { paymentReceivedId, ids },
    });
  }

  toggleDropdownCmd(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    const selectedIteam = this.allItems[this.selectedTabIndex];
    const itemId = selectedIteam.id;
    this.fetchComments(itemId);
    this.isDropdownOpenCmd = !this.isDropdownOpenCmd;
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  toggleMode(mode: string) {
    if (this.selectedModes.includes(mode)) {
      this.selectedModes = this.selectedModes.filter((m) => m !== mode);
    } else {
      this.selectedModes.push(mode);
    }
    this.selectedCount = this.selectedModes?.length;
  }

  onApplyFilters() {
    // this.fetchItems('', {
    //   paymentType: 'Invoice',
    //   paymentMode: this.selectedModes,
    // });
    this.toggleDropdown();
  }

  clearFilters() {
    this.selectedModes = [];
    // this.fetchItems('', { paymentType: 'Invoice', paymentMode: [] });
    this.toggleDropdown();
    this.selectedCount = 0;
  }

  fetchItems() {
    const filter = {
      paymentType: 'Invoice',
    };
    const input = {
      search: this.search,
      filter: filter,
    };
    this.itemService.findAllPaymentsWithPagination(input).subscribe({
      next: (payments) => {
        console.log(payments);

        this.allItems = payments?.payments;

        // Ensure this.itemId is set and matches an item ID before selecting a tab
        if (this.itemId) {
          const targetId = +this.itemId;
          this.selectedTabIndex = this.allItems.findIndex(
            (c: any) => c.id === targetId
          );
          this.selectTab(this.itemId, this.selectedTabIndex); // Select the appropriate tab
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0; // Default to the first tab if no match is found
          }
        } else {
          this.selectedTabIndex = 0; // Default to the first tab if no itemId
        }
      },
      error: (err) => {
        console.error('Error fetching all items:', err);
      },
    });
  }

  // fetchItems(search: string = '', filter: any = { paymentType: 'Invoice' }) {
  //   this.loading = true;
  //   this.itemService.fetchPayments(search, filter).subscribe({
  //     next: (items) => {
  //       this.allItems = items;
  //       if (this.allItems.length > 0) {
  //         this.selectTab(0);
  //       }

  //       if (this.itemId) {
  //         const targetId = +this.itemId;
  //         this.selectedTabIndex = this.allItems.findIndex((c: any) => {
  //           return c.id === targetId;
  //         });
  //         if (this.selectedTabIndex === -1) {
  //           this.selectedTabIndex = 0;
  //         }
  //       } else {
  //         this.selectedTabIndex = 0;
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error fetching all items:', err);
  //     },
  //   });
  // }

  fetchComments(refId: number) {
    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee.employeeId;

    const value = {
      employeeId: employeeId,
      refId: refId,
      activityType: 'Comment',
      type: 'Payment',
    };
    this.loading = true;
    // this.itemService.comments(value).subscribe({
    //   next: (items) => {
    //     this.commentsList = items;
    //   },
    //   error: (err) => {
    //     console.error('Error fetching all items:', err);
    //   },
    // });
  }

  onCommentSubmit(): void {
    if (this.commentsForm.invalid) {
      this.commentsForm.markAllAsTouched();
      return;
    }

    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee.employeeId;
    const selectedIteam = this.allItems[this.selectedTabIndex];
    const refId = selectedIteam.id;

    const data = this.commentsForm.value;

    const createCommentInput = {
      employeeId: employeeId,
      refId: refId,
      type: 'Payment',
      activityType: 'Comment',
      note: data?.comments,
    };

    // this.itemService.createComment(createCommentInput).subscribe({
    //   next: () => {
    //     this.isLoading = false;
    //     const selectedIteam = this.allItems[this.selectedTabIndex];
    //     const itemId = selectedIteam.id;
    //     this.fetchComments(itemId);
    //     this.toastr.success('Successfully.');
    //     this.commentsForm.reset();
    //   },
    //   error: (error) => {
    //     this.isLoading = false;
    //     this.toastr.error(error.message || 'Failed.');
    //   },
    // });
  }

  // selectTab(index: number) {
  //   this.selectedTabIndex = index;
  //   this.itemData = this.allItems[index];
  // }

  onViewDocument() {
    console.log('sdfsdfdsf');
    // const selectedIteam = this.allItems[this.selectedTabIndex];
    const url = this.itemData.paymentUrl;
    this.pdfLoading = true;
    if (url) {
      const token = localStorage.getItem('AUTH_TOKEN');
      fetch(url, {
        method: 'GET',
        headers: {
          authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then((response: any) => response.blob())
        .then((blob: any) => {
          this.pdfLoading = false;
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch((error: any) => {
          console.error('Error:', error);
        });
    }
  }

  downloadPdf(): void {
    const paymentID = this.itemData.id;
    const paymentType = 'Invoice';
    // this.itemService.generatePaymentPdf(paymentID, paymentType).subscribe({
    //   next: (items) => {
    //     const url = items;
    //     fetch_PDF(url, 'paymentReceived');
    //   },
    //   error: (err) => {
    //     this.toastr.error(err.message, 'failed');
    //   },
    // });
  }
}

// @Component({
//   selector: 'upload-payment-received-details-dialog',
//   templateUrl: 'upload-payment-received-details-dialog.html',
//   styleUrls: ['./payment-received-details.component.scss'],
//   standalone: true,
//   imports: [CommonModule, MatDialogModule, MatButtonModule],
// })
// export class UploadPaymentReceivedDetailsDialog {
//   file: any = null;
//   url: any = null;

//   constructor(
//     private toastr: ToastrService,
//     private itemService: PaymentsItemService,
//     private dialogRef: MatDialogRef<UploadPaymentReceivedDetailsDialog>
//   ) { }

//   ngOnInit() {
//     document.addEventListener('dragover', this.preventDefaultBehavior);
//     document.addEventListener('drop', this.preventDefaultBehavior);
//   }

//   preventDefaultBehavior(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDragOver(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDrop(event: DragEvent) {
//     event.preventDefault();

//     if (event.dataTransfer?.files.length) {
//       this.onFileSelected({ target: { files: event.dataTransfer.files } });
//     }
//   }

//   onFileSelected(event: any): void {
//     const input = event.target as HTMLInputElement;
//     if (input.files && input.files.length > 0) {
//       const file = input.files[0];
//       this.file = file;
//     }
//   }

//   uploadDocuments(csvFile: any) {
//     this.itemService.bulkCreatePayment(csvFile).subscribe({
//       next: (response) => {
//         if (response == true) {
//           this.toastr.success('Bulk updated successfully!');
//           this.dialogRef.close('refresh');
//         }
//       },
//       error: (error) => {
//         this.toastr.error(error.message, 'Bulk updated failed');
//         this.dialogRef.close();
//       },
//     });
//   }

//   removeFile(): void {
//     this.file = null;
//     const input = document.querySelector(
//       'input[type="file"]'
//     ) as HTMLInputElement;
//     if (input) {
//       input.value = '';
//     }
//   }

//   onUpload() {
//     this.uploadDocuments(this.file);
//   }

//   ngOnDestroy() {
//     document.removeEventListener('dragover', this.preventDefaultBehavior);
//     document.removeEventListener('drop', this.preventDefaultBehavior);
//   }
// }
